import type { Environment } from './environment.type';
import { roleGroups } from './role-groups';

export const environment: Environment = {
  appVersion: '0.3.0-2f171f84',
  keycloak: {
    issuer: '/auth/realms/bl312-licensing',
    clientId: 'bl312-licensing-app',
  },
  featureFlags: {
    fleetManagement: true,
    administration: true,
  },
  roleGroups,
};
